import './chunk-2452e3d3.js';
import './helpers.js';
import './chunk-8cad1844.js';
import './chunk-590a6902.js';
import './chunk-ea9bc877.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-113685dc.js';
import './chunk-91404fa9.js';
import './chunk-42f463e6.js';
import './chunk-b66a83ce.js';
import './chunk-97f201e0.js';
import './chunk-40f06d9c.js';
import { D as Datepicker } from './chunk-5f0c3fc4.js';
export { D as BDatepicker } from './chunk-5f0c3fc4.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/datepicker.js
// module id = m6gj
// module chunks = 0 1